var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"bgimage",rawName:"v-bgimage",value:(_vm.item.image),expression:"item.image"}],staticClass:"banner"},[_c('div',{staticClass:"banner-inner inner"},[_c('div',{staticClass:"banner-title"},[_vm._v(_vm._s(_vm.item.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }